import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { colors, Typography } from '@mui/material';
import { Page, Header, } from 'components';
import _ from 'underscore';
import DashboardInspect from '../Dashboard/components/Inspect/DashboardInspect';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
	marginAdjust: {
		marginTop: theme.spacing(-8),
		marginLeft: theme.spacing(-8),
		marginRight: theme.spacing(-10),
		marginBottom: theme.spacing(-10),
	}
}));

const SRCAAlgorithmGeneric = () => {
	const [value, setValue] = useState('1');

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const classes = useStyles();

	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const matchOne = {
		params: {
			id: 18
		}
	};

	const matchTwo = {
		params: {
			id: 12
		}
	};

	return (
		<Page className={classes.root} title="SRCA Algorithm">
			<Header module="Modules" view="SMART ROOT CAUSE ANALYSIS Algorithm" />
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={handleChange} aria-label="">
						<Tab value="1" label="Fault Classification - Test Set" />
						<Tab value="2" label="Fault/Cluster Results" />
						<Tab value="3" label="Fault/Cluster Dynamics" />
					</TabList>
				</Box>
				<TabPanel value="1" index={0}>
					<div
						className={clsx(classes.marginAdjust)}
					>
						<DashboardInspect
							match={matchOne}
							headerHidden
						/>
					</div>
				</TabPanel>
				<TabPanel value="2" index={0}>
					<div
						className={clsx(classes.marginAdjust)}
					>
						<DashboardInspect
							match={matchTwo}
							headerHidden
						/>
					</div>
				</TabPanel>
				<TabPanel value="3">
					<iframe title="123" width="100%" height={800} src="https://rinnos.celfinet.com/media/srca/graph.html" />
				</TabPanel>
			</TabContext>
		</Page>
	);
};

export default SRCAAlgorithmGeneric;
